import React, { memo } from 'react'

import { Button, CircleCheck, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'

function AssistPosted() {
  return (
    <div className="assist-posted">
      <span className="enhance-model-panel__title cgt-heading-50">Request for Designer Assistance</span>

      <div className="assist-posted__content">
        <div className="assist-posted__icon" aria-hidden="true">
          <Icon svgComponent={CircleCheck} />
        </div>

        <div className="assist-posted__text">
          <p className="assist-posted__title cgt-heading-100">Request submitted</p>
          <p className="assist-posted__description cgt-body-base">
            {"Your project has been posted to the open list for freelance designers. "
              + "You'll be notified when someone applies"}
          </p>
        </div>
        <Button
          customClass="assist-posted__button"
          type="secondary"
          size="medium"
          href="/profile/projects"
          target="_blank"
          rel="noopener noreferrer"
        >
          Go to My 3D Projects
        </Button>
      </div>
    </div>
  )
}

export default memo(AssistPosted)
